export default __webpack_public_path__ + "static/media/logout.1336c4b6.svg";